<template>
  <el-card class='sockets-card' :body-style='{padding:0}'>
    <div slot="header" class="clearfix">
      <span>Sockets</span>
    </div>
    <div v-for="(board, isb) in $store.state.boards" style='padding: 10px'>
      <h4 class="board-header"><i class="el-icon-info" @click='showBoardResults(isb)'></i> Board {{board.id}}<span style="color:#393;" v-if="board.running"> (running test)</span> has run
        {{board.tests_done}} tests <span style="color:#939" v-if="board.error">{{board.error}}</span></h4>
      <el-table :data='tableData(board)' style="width:100%" :header-cell-style="{color: '#000'}" :cell-style="getCellStyle">
        <el-table-column width="75px" prop="socket" label='Socket'>
          <template slot-scope="scope">
           {{scope.row.socket}}
            <i class="el-icon-info" v-if='hasSocketResults(isb,scope.row.socket)' @click='showSocketResults(isb,scope.row.socket)'></i> 
          </template>
        </el-table-column>
        <el-table-column width="80px" prop="state" label='State'></el-table-column>
        <el-table-column width="75px" prop="current_retry" label='Retried'></el-table-column>
        <el-table-column prop="chip_id" label='Chip ID'></el-table-column>
        <el-table-column width="75px" prop="result" label='Result'></el-table-column>
        <el-table-column prop="fail_tray" label='Fail tray'></el-table-column>
        <el-table-column width="75px" prop="source_index" label='Source'></el-table-column>
        <el-table-column width="75px" prop="v_tests" label='Tests'></el-table-column>
        <el-table-column width="75px" prop="v_ok" label='Ok'></el-table-column>
        <el-table-column width="75px" prop="v_fails" label='Fails'></el-table-column>
        <el-table-column width="75px" prop="v_yield" label='Yield'></el-table-column>
        <el-table-column width="75px" prop="retries" label='Retries'></el-table-column>
      </el-table>
    </div>
    <el-dialog :title="'Result breakdown for ' + dialog.what" :visible.sync="dialog.visible" width="500px">
      <results-plot :data="dialog.data"></results-plot>
    </el-dialog>
  </el-card>
</template>

<script>
  import ResultsPlot from './results-plot'

  export default {
    name: 'sockets-card',
    components: { ResultsPlot },
    data() {
      return {
        dialog: {
          visible: false,
          what: '',
          data: { ok: 0, fail: {} }
        }
      }
    },
    methods: {
      hasBoardResults(ib) {
        if(!this.$store.state.results.boards){
          return false
        }
        return this.$store.state.results.boards[ib].stats.tests > 0
      },
      showBoardResults(ib) {
        this.dialog.what = `board ${this.$store.state.boards[ib].id}`
        this.dialog.data = this.$store.state.results.boards[ib].stats
        this.dialog.visible = true
      },
      hasSocketResults(ib,is) {
        if( !this.hasBoardResults(ib) ) {
          return false
        }
        if(is >= this.$store.state.results.boards[ib].sockets.length) {
          return false
        }
        return this.$store.state.results.boards[ib].sockets[is].tests > 0
      },
      showSocketResults(ib,is) {
        this.dialog.what = `board ${this.$store.state.boards[ib].id} socket ${is}`
        this.dialog.data = this.$store.state.results.boards[ib].sockets[is]
        this.dialog.visible = true
      },
      tableData(board) {
        var data = []
        for( var isk = 0; isk < board.sockets.length; isk++ ){
          var sk = board.sockets[isk]
          data.push({
            'socket': isk,
            'chip_id': sk.chip_id,
            'fail_tray': sk.fail_tray,
            'result': sk.result,
            'current_retry': sk.current_retry,
            'retries': sk.retries,
            'source_index': sk.source_index,
            'state': board.running && sk.state !== 'disabled' && sk.state !== 'stopped' ? 'running' : sk.state,
            'v_tests': sk.validation_tests,
            'v_ok': sk.validation_oks,
            'v_fails': sk.validation_fails,
            'v_yield': sk.validation_tests === 0 ? 0 : Math.round(100 * (sk.validation_oks * 100.0 / (sk.validation_oks + sk.validation_fails))) / 100
          })
        }
        return data
      },
      getCellStyle(cell) {
        switch(cell.row[cell.column.property]){
          case 'ready':
            return {'background-color': '#ABF', 'text-align': 'center', 'color': '#222', 'text-transform': 'capitalize'}
          case 'running':
            return {'background-color': '#F6E1A3', 'text-align': 'center', 'color': '#222', 'text-transform': 'capitalize'}
          case 'done':
          case 'ok':
            return {'background-color': '#AFA', 'text-align': 'center', 'color': '#505', 'text-transform': 'capitalize'}
          case 'retry':
          case 'fail':
            return {'background-color': '#FAA', 'text-align': 'center', 'color': '#055', 'text-transform': 'capitalize'}
          case 'abort':
            return {'background-color': '#F00', 'text-align': 'center', 'color': '#FF0', 'text-transform': 'uppercase', 'font-weight': 'bold'}
          case 'empty':
            return {'background-color': '#FFF', 'text-align': 'center', 'color': '#111', 'text-transform': 'capitalize'}
          case 'disabled':
          case 'stopped':
            return {'background-color': '#666', 'text-align': 'center', 'color': '#DDD', 'text-transform': 'capitalize'}
        }
        return ''
      }
    }
  }
</script>

<style>
  .board-header {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .sockets-card {
    width: 1200px;
  }
</style>



// WEBPACK FOOTER //
// sockets-card.vue?55d4e5e5